import React, { useState, useEffect, useContext } from 'react';
import { GlobalContext } from '../../context/GlobalState';
import CommentsList from '../CommentsList';
import "bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import db from '../Firebase';
import { toast } from 'react-toastify';

const MovieDetails = (props) => {

        const notifyAdded = () => toast.success("Succesfully added movie to watchlist.", {
            draggable: false,
            closeOnClick: false,
            closeButton: false,
            autoClose: 2000,
            theme: "light",
            bodyClassName: "grow-font-size"
        })

        const notifyForm = () => toast.error("Please fill in every field to add a comment!", {
            draggable: false,
            closeOnClick: false,
            closeButton: false,
            autoClose: 4000,
            theme: "light",
            bodyClassName: "grow-font-size"
        })

        const [commentFieldUsername, setCommentFieldUsername] = useState();
        const [commentField, setCommentField] = useState();
        const moviesCollection = db.collection("Movies");
        const [commentsArray, setCommentsArray] = useState([]);

        const {addMovieToWatchlist, movieWatchlist: watchlist} = useContext(GlobalContext);

        let storedMovie = watchlist.find(m => m.id === props.currentMovie.id);

        const watchlistDisabled = storedMovie ? true : false;

        const handleCommentName = (e) => {
            console.log(e.target.value);
            setCommentFieldUsername(e.target.value);
        }

        const handleComment = (e) => {
            console.log(e.target.value);
            setCommentField(e.target.value);
        }

        const postComment = () => {
            if (!commentFieldUsername || !commentField) {
                notifyForm();
            } else {
                moviesCollection.doc(props.currentMovie.id.toString()).collection("comments")
                .add({name: commentFieldUsername, comment: commentField})
                .then(() => {
                    console.log("Comment was posted!");
                    getComments();
                })
                setCommentFieldUsername("");
                setCommentField("");
            }
        }

        const getComments = () => {
            setCommentsArray([]);
            moviesCollection.doc(props.currentMovie.id.toString()).collection("comments").get()
                .then(response => {
                    response.forEach(doc => {
                        setCommentsArray(commentsArray => [...commentsArray, {name: doc.data().name, comment: doc.data().comment}]);
                    })
                })

                .catch(error => {
                    console.log(error)
                })
        }

        return (
                <div className="container" onLoad={getComments}>
                    <div className="row" style={{paddingTop: 50, fontSize: "15px"}}>
                        <div className="goBack" style={{cursor: "pointer"}} onClick={props.closeMovieDetails}>
                            <i className="bi bi-arrow-left-short"></i>
                            <span >Go back</span>
                        </div>
                        <div className="imgPoster">
                        {props.currentMovie.poster_path == null ? <img src={"https://upload.wikimedia.org/wikipedia/commons/a/ac/No_image_available.svg"}/> : 
                        <img src={"https://image.tmdb.org/t/p/w500" + props.currentMovie.poster_path} />}
                        </div>
                    <div className="col-sm">
                        <div className="infoContainer">
                            <h1>{props.currentMovie.title}</h1>
                            <p>Release date: {props.currentMovie.release_date}</p>
                            <h4>Description:</h4>
                            <p>{props.currentMovie.overview}</p>
                            <button onClick={() => {addMovieToWatchlist(props.currentMovie); notifyAdded()}} disabled={watchlistDisabled} className="btn-warning" type="submit">Add to watchlist</button>
                        </div>
                    </div>
                    </div>

                    <div className="row" style={{paddingTop: 50, fontSize: "15px"}}>
                        <h2>Comments</h2>
                        <CommentsList comments={commentsArray} />
                        <form style={{paddingTop: 15}}>
                            <div className="form-group">
                                <label className="username">Name</label>
                                <input onChange={handleCommentName} value={commentFieldUsername} type="text" className="form-control" id="inputUsername" placeholder="Enter name" style={{width: "25%", fontSize: "15px"}} />
                                <label className="comment">Comment</label>
                                <textarea onChange={handleComment} value={commentField} className="form-control" id="inputComment" rows="3" style={{width: "25%", fontSize: "15px"}} placeholder="Write a comment about this movie..."></textarea>
                                <button id="postCommentBtn" type="button" onClick={postComment} className="btn-warning" style={{marginTop: 5}}>Submit</button>
                            </div>
                        </form>
                        </div>
                </div>
            );     
}

export default MovieDetails;